import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=642b2c48"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642b2c48')) {
      api.createRecord('642b2c48', component.options)
    } else {
      api.reload('642b2c48', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=642b2c48", function () {
      api.rerender('642b2c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agents/manage.vue"
export default component.exports